/// <reference path="./index.d.ts" />

import { ITemplateCompileAttributes } from ".";

export function TemplateCompileDirective($compile: angular.ICompileService): ng.IDirective {
    return {
        restrict: 'EA',
        // transclude: true,
        // template: '<ng-transclude></ng-transclude>',
        link: (scope: angular.IScope,
            elements: any,
            attributes: ITemplateCompileAttributes): void => {
            let currentScope: angular.IScope;

            scope.$watch(
                function (scope) {
                    return scope.$eval(attributes.contents);
                },
                function (value) {
                    if (value) {
                        if (currentScope != null && currentScope != undefined) {
                            currentScope.$destroy();
                        }

                        elements.html(value);
                        currentScope = scope.$new();
                        $compile(elements.contents())(currentScope);
                    }
                }
            )
        }
    };
}

TemplateCompileDirective.$inject = ["$compile"];